import { UseQueryResult } from '@tanstack/react-query'
import { immer } from 'zustand/middleware/immer'

import { getOnlyDate } from '~/astra'
import { BlockScheduleMetricsResponse } from '~/clients/optimus-client'

import { Slice } from '../store'
import { DrawerActions, DrawerState, LocationDay } from './types'

export const tabs = [
    { label: 'Kapasitetsmål', value: 'capacity' },
    { label: 'Kommentar', value: 'comments' },
    { label: 'Programhistorikk', value: 'historicData' },
] as const
export type TabValue = (typeof tabs)[number]['value']

type State = {
    selectedLocationDay: LocationDay | null
    commentInput: Record<string, string>
    blockEstimations?: UseQueryResult<Record<number, BlockScheduleMetricsResponse>, Error>
} & DrawerState<TabValue>

const initialState: State = {
    isDrawerOpen: true,
    activeDrawerTab: 'capacity',
    selectedLocationDay: null,
    commentInput: {},
    blockEstimations: undefined,
}

type Actions = {
    actions: {
        setNewComment: (comment: string) => void
        unselectDay: () => void
        setBlockEstimations: (estimation: UseQueryResult<Record<number, BlockScheduleMetricsResponse>, Error>) => void
    } & DrawerActions<TabValue, LocationDay | undefined>
}

export type SurgerySchedulerSlice = {
    surgeryScheduler: State & Actions
}

export const createSurgerySchedulerSlice: Slice<SurgerySchedulerSlice> = immer(set => ({
    surgeryScheduler: {
        ...initialState,
        actions: {
            openDrawer: (locationDay?: LocationDay) => {
                set(state => {
                    if (locationDay) {
                        state.surgeryScheduler.selectedLocationDay = locationDay
                    }
                    state.surgeryScheduler.isDrawerOpen = true
                })
            },
            closeDrawer: () => {
                set(state => {
                    state.surgeryScheduler.isDrawerOpen = false
                    state.surgeryScheduler.selectedLocationDay = null
                })
            },
            toggleDrawer: () => {
                set(state => {
                    state.surgeryScheduler.isDrawerOpen = !state.surgeryScheduler.isDrawerOpen
                })
            },
            setActiveDrawerTab: (tabValue: TabValue) => {
                set(state => {
                    state.surgeryScheduler.activeDrawerTab = tabValue
                })
            },
            setNewComment: commentText => {
                set(state => {
                    if (!state.surgeryScheduler.selectedLocationDay) return

                    const commentKey = `${state.surgeryScheduler.selectedLocationDay.locationId}-${getOnlyDate(state.surgeryScheduler.selectedLocationDay.date)}`

                    state.surgeryScheduler.commentInput[commentKey] = commentText
                })
            },
            unselectDay: () => {
                set(state => {
                    state.surgeryScheduler.selectedLocationDay = null
                })
            },
            setBlockEstimations: (estimationQuery: UseQueryResult<Record<number, BlockScheduleMetricsResponse>, Error>) => {
                set(state => {
                    state.surgeryScheduler.blockEstimations = estimationQuery
                })
            },
        },
    },
}))
